import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PatchIncidentActivity(reply, idIncidentactivity, activityType) {
  try {
    const apiConfig = await getApiConfig();

    const req = `${apiConfig.BASE_URL}incidentactivity/${idIncidentactivity}`;
    const state = reply ==="aceptar" ? '910a0738-261a-4d47-bc42-366108c6471f' : '55ccb2f3-cb38-49ca-a220-08f9af419336';

      const userPatch = {
        state: state,
      };
  
    const response = await axios.patch(req, userPatch, apiConfig.HEADERS_CONFIG,{
      });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
